/* Avenella theme behaviour: mobile menu, one-video-at-a-time, scrapbook,
   scrolling rows and Klaviyo signups. Every block checks its elements exist,
   so the file is safe on every page. */
(function () {
  var reduced = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var narrow = function () { return matchMedia('(max-width: 820px)').matches; };
  var $ = function (id) { return document.getElementById(id); };
  var AV = window.AV || {};

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* mobile menu */
    var menuBtn = $('menu-btn'), mnav = $('mobile-nav');
    if (menuBtn && mnav) {
      menuBtn.addEventListener('click', function () {
        var open = mnav.hidden;
        mnav.hidden = !open;
        menuBtn.setAttribute('aria-expanded', String(open));
        menuBtn.textContent = open ? 'Close' : 'Menu';
      });
      mnav.addEventListener('click', function (e) {
        if (e.target.closest('a')) {
          mnav.hidden = true;
          menuBtn.setAttribute('aria-expanded', 'false');
          menuBtn.textContent = 'Menu';
        }
      });
    }

    /* one video at a time (looping scrapbook clips excepted) */
    document.addEventListener('play', function (e) {
      document.querySelectorAll('video').forEach(function (v) {
        if (v !== e.target && !v.hasAttribute('data-loop')) v.pause();
      });
    }, true);

    initBook();
    initRow('wall', 'wall-prev', 'wall-next');
    initRow('social', 'social-prev', 'social-next');
    initSignup('early-form', 'early-email', 'early-msg', function (form) {
      var done = $('early-done');
      form.hidden = true;
      if (done) done.hidden = false;
    });
    initSignup('signup', 'signup-email', 'signup-msg', function (form, msg) {
      msg.textContent = AV.doneText || "You're on the list.";
      form.reset();
    });
  });

  function initRow(rowId, prevId, nextId) {
    var row = $(rowId), prev = $(prevId), next = $(nextId);
    if (!row) return;
    var scroll = function (d) {
      row.scrollBy({ left: d * row.clientWidth * 0.8, behavior: reduced() ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { scroll(-1); });
    if (next) next.addEventListener('click', function () { scroll(1); });
  }

  /* ---- Klaviyo signup (client subscriptions API, public key only) ---- */
  function subscribe(email, source) {
    if (!AV.klaviyoCompany || !AV.klaviyoList) return Promise.reject(new Error('not-connected'));
    /* profile properties act as the tag: segment on "Pre-launch signup" = true */
    var props = { 'Signup form': source };
    if (AV.prelaunch) {
      props['Pre-launch signup'] = true;
      source += ' (pre-launch)';
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(AV.klaviyoCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: AV.klaviyoList } } }
        }
      })
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo-' + r.status); });
  }

  function initSignup(formId, inputId, msgId, onDone) {
    var form = $(formId), input = $(inputId), msg = $(msgId);
    if (!form || !input || !msg) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.textContent = 'Please enter your email address.';
        input.focus();
        return;
      }
      var btn = form.querySelector('button');
      if (btn) btn.disabled = true;
      msg.textContent = '';
      subscribe(email, form.getAttribute('data-source') || 'Website')
        .then(function () { onDone(form, msg); })
        .catch(function (err) {
          msg.textContent = err.message === 'not-connected'
            ? "Signups aren't connected yet (add the Klaviyo list ID in theme settings)."
            : 'Something went wrong. Please try again, or email hello@avenella.com.';
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---- scrapbook ---- */
  function initBook() {
    var book = $('book'), cover = $('book-cover'), spread = $('book-spread');
    if (!book || !cover || !spread) return;
    var pages = [].slice.call(spread.querySelectorAll('.sb-page'));
    var TOTAL = pages.length + 1, cur = 1, busy = false;
    var titles = { 1: 'The cover' };
    pages.forEach(function (p) { titles[+p.dataset.n] = p.dataset.tab; });
    var prev = $('book-prev'), next = $('book-next'), ind = $('book-indicator'), dots = $('book-dots');

    for (var i = 1; i <= TOTAL; i++) {
      var li = document.createElement('li'), b = document.createElement('button');
      b.type = 'button'; b.textContent = i; b.dataset.go = i;
      b.setAttribute('aria-label', 'Page ' + i + ': ' + titles[i]);
      li.appendChild(b); dots.appendChild(li);
    }
    function pageEl(n) { return pages.filter(function (p) { return +p.dataset.n === n; })[0]; }
    function syncMedia() {
      pages.forEach(function (p) {
        var on = +p.dataset.n === cur;
        p.querySelectorAll('video').forEach(function (v) {
          if (!on) { v.pause(); return; }
          if (v.hasAttribute('data-loop') && !reduced()) {
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          }
        });
      });
    }
    function render() {
      cover.hidden = cur !== 1;
      spread.hidden = cur === 1;
      pages.forEach(function (p) { p.hidden = +p.dataset.n !== cur; });
      ind.textContent = cur === 1 ? 'The cover' : 'Page ' + cur + ' of ' + TOTAL + ': ' + titles[cur];
      prev.disabled = cur === 1;
      next.setAttribute('aria-label', cur === 1 ? 'Open the book' : cur === TOTAL ? 'Back to the cover' : 'Next page');
      dots.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-current', String(+b.dataset.go === cur)); });
      syncMedia();
    }
    function done() { busy = false; }
    function go(n) {
      n = Math.max(1, Math.min(TOTAL, n));
      if (n === cur || busy) return;
      var from = cur, fwd = n > from;
      if (reduced()) { cur = n; render(); return; }
      busy = true;
      if (from === 1) {
        book.classList.add('opening');
        setTimeout(function () {
          book.classList.remove('opening'); cur = n; render(); done();
          spread.classList.add('fade-in');
          setTimeout(function () { spread.classList.remove('fade-in'); }, 460);
        }, narrow() ? 280 : 480);
        return;
      }
      if (n === 1) {
        spread.classList.add('fade-in'); cur = 1; render(); cover.classList.add('fade-in');
        setTimeout(function () { cover.classList.remove('fade-in'); spread.classList.remove('fade-in'); done(); }, 460);
        return;
      }
      if (narrow()) {
        cur = n; render();
        var np = pageEl(n);
        np.classList.add(fwd ? 'slide-fwd' : 'slide-back');
        setTimeout(function () { np.classList.remove('slide-fwd', 'slide-back'); done(); }, 420);
        if (book.getBoundingClientRect().top < 0) book.scrollIntoView({ block: 'start' });
        return;
      }
      var old = pageEl(from), half = old.querySelector(fwd ? '.mem' : '.sb-left'), leaf = half.cloneNode(true);
      leaf.classList.add('leaf', fwd ? 'leaf-fwd' : 'leaf-back');
      leaf.setAttribute('aria-hidden', 'true'); leaf.setAttribute('inert', '');
      leaf.querySelectorAll('video').forEach(function (v) { v.removeAttribute('autoplay'); v.preload = 'none'; });
      spread.appendChild(leaf); cur = n; render();
      var cleanup = function () { if (leaf.parentNode) leaf.parentNode.removeChild(leaf); done(); };
      leaf.addEventListener('animationend', function (e) { if (e.target === leaf) cleanup(); });
      setTimeout(cleanup, 1100);
    }
    var openBtn = $('cover-open');
    if (openBtn) openBtn.addEventListener('click', function () { go(2); });
    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur === TOTAL ? 1 : cur + 1); });
    dots.addEventListener('click', function (e) { var b = e.target.closest('[data-go]'); if (b) go(+b.dataset.go); });
    book.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    var t0 = null;
    book.addEventListener('touchstart', function (e) { t0 = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, { passive: true });
    book.addEventListener('touchend', function (e) {
      if (!t0) return;
      var dx = e.changedTouches[0].clientX - t0.x, dy = e.changedTouches[0].clientY - t0.y;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) go(cur + (dx < 0 ? 1 : -1));
      t0 = null;
    });
    render();
  }
})();
